import { DurableStorageKeys, localStore } from './storage';

/**
 * Observability identifiers attached to every API request so backend logs can
 * fingerprint TV devices behind NAT.
 */

export const DEVICE_ID_STORAGE_KEY = DurableStorageKeys.DEVICE_ID;

// In-memory fallback. Covers private-mode / storage errors and keeps the value
// alive across an unauthenticated storage reset performed by the auth gate.
let inMemoryDeviceId: string | undefined;

const generateUuid = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for runtimes without crypto.randomUUID (older TV webviews).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

/**
 * Returns a stable per-device UUID, generating and persisting it on first use.
 * Works for every device class (including the Android WebView used by the
 * tv-wrapper APK) and never throws if storage is unavailable.
 */
export const getDeviceId = (): string => {
  if (inMemoryDeviceId) return inMemoryDeviceId;

  const stored = localStore.read(DEVICE_ID_STORAGE_KEY);
  if (stored) {
    inMemoryDeviceId = stored;
    return stored;
  }

  const generated = generateUuid();
  inMemoryDeviceId = generated;
  localStore.write(DEVICE_ID_STORAGE_KEY, generated);
  return generated;
};
